import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import DashLayout from "@/components/DashLayout";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";

export default function SuperSubmissions() {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get("/submissions"); setItems(data); };
  useEffect(() => { load(); }, []);
  const mark = async (id, status) => { await api.put(`/submissions/${id}`, { status }); load(); };

  return (
    <DashLayout variant="super" title="School Submissions">
      <div className="text-sm text-slate-500 mb-4">Requests received via "List Your School" form.</div>
      <div className="bg-white rounded-lg border border-slate-200">
        <Table>
          <TableHeader><TableRow>
            <TableHead>School</TableHead><TableHead>City</TableHead><TableHead>Contact</TableHead>
            <TableHead>Phone</TableHead><TableHead>Status</TableHead><TableHead className="text-right">Actions</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {items.map((s) => (
              <TableRow key={s.id} data-testid={`row-submission-${s.id}`}>
                <TableCell><div className="font-semibold">{s.school_name}</div><div className="text-xs text-slate-500">{s.board} · {s.school_type}</div></TableCell>
                <TableCell>{s.city}</TableCell>
                <TableCell><div>{s.contact_name}</div><div className="text-xs text-slate-500">{s.contact_email}</div></TableCell>
                <TableCell>{s.contact_phone}</TableCell>
                <TableCell>
                  <Badge variant={s.status === "new" ? "default" : "outline"}>{s.status}</Badge>
                </TableCell>
                <TableCell className="text-right space-x-1">
                  <Button size="sm" variant="outline" onClick={() => mark(s.id, "contacted")} data-testid={`mark-contacted-${s.id}`}>Contacted</Button>
                  <Button size="sm" variant="outline" onClick={() => mark(s.id, "onboarded")} data-testid={`mark-onboarded-${s.id}`}>Onboarded</Button>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-8">No submissions yet</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </DashLayout>
  );
}
